import { configureStore } from '@reduxjs/toolkit';
import globalConfigReducer from './slices/globalConfigSlice';
import userReducer from './slices/userSlice';
import rootReducer from './reducers';
import accountReducer from './slices/userSlice';
import caseCreationReducer from './slices/chatContextSlice';

export const store = configureStore({
    reducer: {
        globalConfig: globalConfigReducer,
        account: accountReducer,
        caseCreation: caseCreationReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
